import styled from "styled-components"
import { Colors } from "src/theme"
import ProgressiveImage from "react-progressive-bg-image"

export const ContainerFluid = styled.div`
  text-align: center;
  margin-top: 5rem;
`
export const Container = styled.div`
  width: 65%;
  margin: auto;

  @media (max-width: 1600px) {
    width: 80%;
  }

  @media (max-width: 1400px) {
    width: 90%;
  }
`
export const Header6 = styled.h6`
  font-weight: 500;
  color: #10ad62;
`
export const Header3 = styled.h3`
  margin-top: 0.5rem;
`

export const SingleBlogContainer = styled.div`
  display: flex;
  margin: 4%;
  @media (max-width: 900px) {
    flex-direction: column;
    padding-inline: 0%;
  }
  @media (max-width: 1100px) {
    margin: 4%;
  }
`

export const TabContainer = styled.div`
  width: 100%;
  display: flex;
  margin:auto @media (max-width: 900px) {
    width: 100%;
  }
`
export const BlogListContainer = styled.div`
  width: 40%;
  display: flex;
  justify-content: center;
  margin-left: 1rem;
`
export const DivCard = styled.div`
  height: auto;
  min-height: 9rem;
`
export const Card = styled.div`
  max-height: 425px;
  min-height: 9rem;
  max-width: 400px;
  min-width: 400px;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 11px;
  opacity: 1;
  padding: 10px 12px 0px 12px;
  top: 100px;
  font-size: 20px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 2px;
    border-left: 3px solid ${Colors.primary};
  }
  ::-webkit-scrollbar-thumb {
    background-color: #c4c6c5;
  }
`
export const Content = styled.div`
  font-weight: 500;
  font-size: 18px;
`
export const BlogHeading = styled.div`
  margin-top: 20px;
  margin-bottom: 8px;
  font-size: 32px;
  font-weight: 600;
  padding: 0 20px;
`
export const MoreBlogContainer = styled.div`
  display: flex;
  margin: 15px 0;
`

export const ImageContainer = styled.div`
  width: 76px;
  height: 76px;
  margin-right: 8px;
`
export const BlogDetail = styled.div`
  display: flex;
  flex-direction: column;
`
export const Heading = styled.div`
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  margin-bottom: 3px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  height: 40px;
  max-width: 270px;
`

export const TitleTxt = styled.h1`
  font-family: "Source Sans Pro", sans-serif;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 3px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 32px;
  width: 100%;
  margin-bottom: 1.2rem;
`

export const ClientDetail = styled.div`
  display: flex;
  align-items: center;
`
export const ClientImageSection = styled.div`
  height: 2rem;
  width: 2rem;
  border-radius: 25px;
  overflow: hidden;

  margin-right: 10px;
`
export const ClientName = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #535353;
  font-family: "Source Sans Pro", sans-serif;
`
export const BlogDateTime = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #858585;
  font-family: "Source Sans Pro", sans-serif;
`

export const TopSection = styled.div`
  height: 91%;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 2px;
    border-left: 3px solid ${Colors.primary};
  }
  ::-webkit-scrollbar-thumb {
    background-color: #c4c6c5;
  }
`

export const DescText = styled.div<any>`
  display: flex;
  flex-direction: column;
`

export const BottomSection = styled.div`
  height: 18%;
`
export const BottomLine = styled.div`
  height: 1px;
  width: 90px;
  margin: 8px 0px;
  border-radius: 15px;
`

export const BannerImageContainer = styled.div`
  // height: 100%;
  width: 100%;
`
export const BannerImage = styled(ProgressiveImage)`
  background-image: url('${props => props.src}');
  height:100%;
  width:100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  height:300px;
  backface-visibility: visible
  @media (max-width: 900px) {
    height:180px;
  }
  
`

export const MoreBlogImage = styled(ProgressiveImage)`
    background-image:url('${props => props.src}');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
 `
export const TagContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`
export const TagsList = styled.div`
  width: fit-content;
  border: 1px solid #4aa958;
  padding: 1px 8px;
  border-radius: 15px;
  font-weight: 600;
  margin: 5px;
  cursor: pointer;
`
